import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { WhoAmIService } from 'src/app/auth/services/whoami.service';

@Injectable({
  providedIn: 'root',
})
export class HasUserRoleGuard {
  private whoami = inject(WhoAmIService);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    if (this.whoami.isUser() || this.whoami.isOwner()) {
      return of(true);
    } else {
      if (this.whoami.isRoot()) {
        this.router.navigate(['/analytics']);
      } else if (this.whoami.isAuthenticated()) {
        this.router.navigate(['/me']);
      } else {
        this.router.navigate(['/auth/login']);
      }
      return of(false);
    }
  }
}
